import React, {useEffect, useState} from 'react';
import './index.css';
import {Link, useLocation} from "react-router-dom";
import Hand from '../../assets/images/bottomNavigationMenu/hand.svg';
import Candles from '../../assets/images/bottomNavigationMenu/candles.svg';
import Tasks from '../../assets/images/bottomNavigationMenu/tasks.svg';
import Links from '../../assets/images/bottomNavigationMenu/link.svg';
import Coins from '../../assets/images/bottomNavigationMenu/coins.svg';

const BottomNavigationMenu = () => {
    let location = useLocation();
    const currentRoute = location.pathname.replace('/', '');
    const [hasRedDot, setHasRedDot] = useState(true);

    useEffect(() => {
        if (currentRoute === 'tasks') {
            setHasRedDot(false);
        }
    }, [currentRoute])


    return (
        <div className="bnm-container">
            <div className="bnm-inContainer">
                <Link to="/" className={`bnm-items ${currentRoute === '' ? 'isActive' : ''}`}>
                    <img alt="Jace Tapp" src={Hand} className={`bnm-image ${currentRoute === '' ? 'isActive' : ''}`}/>
                    <p className="text-white fs10 lineNumber1 mw-50 text-center">Hi Jet!</p>
                </Link>

                <Link to="/signals" className={`bnm-items ${currentRoute === 'signals' ? 'isActive' : ''}`}>
                    <img alt="Jace Tapp" src={Candles} className={`bnm-image ${currentRoute === 'signals' ? 'isActive' : ''}`}/>
                    <p className="text-white fs10 lineNumber1 mw-50 text-center">Alarms</p>
                </Link>

                <Link to="/tasks" className={`bnm-items ${currentRoute === 'tasks' ? 'isActive' : ''}`}>
                    <img alt="Jace Tapp" src={Tasks} className={`bnm-image ${currentRoute === 'tasks' ? 'isActive' : ''}`}/>
                    <p className="text-white fs10 lineNumber1 mw-50 text-center">Earn</p>
                    {hasRedDot && <div className="redDot"/>}
                </Link>

                <Link to="/affiliate" className={`bnm-items ${currentRoute.includes('affiliate') ? 'isActive' : ''}`}>
                    <img alt="Jace Tapp" src={Links} className={`bnm-image ${currentRoute.includes('affiliate') ? 'isActive' : ''}`}/>
                    <p className="text-white fs10 lineNumber1 mw-50 text-center">Frens</p>
                </Link>

                <Link to="/checkout" className={`bnm-items ${currentRoute === 'checkout' ? 'isActive' : ''}`}>
                    <img alt="Jace Tapp" src={Coins} className={`bnm-image ${currentRoute === 'checkout' ? 'isActive' : ''}`}/>
                    <p className="text-white fs10 lineNumber1 mw-50 text-center">Claim</p>
                </Link>
            </div>
        </div>
    );
}

export default BottomNavigationMenu;
